export interface StoreBreakdownItem {
  store_id: string;
  store_name: string;
  api_key_masked?: string;
  revenue_brl: number;
  revenue_cop: number;
  orders: number;
  last_sync_status?: 'pending' | 'success' | 'error';
  last_sync_at?: string;
}

export interface SellerStoreIntegration {
  id: string;
  user_id: string;
  platform: 'mastershop';
  api_key: string;
  store_name?: string;
  is_active: boolean;
  last_sync_at?: string;
  last_sync_status?: 'pending' | 'success' | 'error';
  last_error_message?: string;
  last_sync_revenue_brl?: number;
  last_sync_revenue_cop?: number;
  last_sync_orders?: number;
  created_at: string;
  updated_at: string;
}

export interface SellerRevenueMonthly {
  id: string;
  user_id: string;
  year_month: string; // Ex: '2026-10'
  total_revenue: number; // Consolidado em BRL
  revenue_cop?: number; // Consolidado em COP
  currency: string;
  exchange_rate_used?: number;
  total_orders: number;
  store_count?: number;
  store_breakdown?: StoreBreakdownItem[];
  current_milestone_target: number; // 100000, 250000, 500000, 1000000
  claimed_milestones: string[]; // ["100k", "250k"]
  created_at: string;
  updated_at: string;
}

export interface MilestoneTier {
  id: string;
  target: number;
  label: string;
  badge: string;
  rewardTitle: string;
  rewardDescription: string;
  color: string;
}

export const REVENUE_MILESTONES: MilestoneTier[] = [
  {
    id: '100k',
    target: 100000,
    label: '100K',
    badge: '🚀 Vendedor 100k',
    rewardTitle: 'Recompensa 100K Desbloqueada!',
    rewardDescription: 'Parabéns! Você alcançou a incrível marca de R$ 100.000 em faturamento no mês!',
    color: '#0FFF55'
  },
  {
    id: '250k',
    target: 250000,
    label: '250K',
    badge: '⚡ Vendedor 250k',
    rewardTitle: 'Recompensa 250K Desbloqueada!',
    rewardDescription: 'Extraordinário! R$ 250.000 faturados! Você está no topo da elite de e-commerce.',
    color: '#00F0FF'
  },
  {
    id: '500k',
    target: 500000,
    label: '500K',
    badge: '👑 Vendedor 500k (Half Million)',
    rewardTitle: 'Recompensa 500K Desbloqueada!',
    rewardDescription: 'Meio milhão de faturamento! Você domina o mercado com maestria.',
    color: '#FFB800'
  },
  {
    id: '1m',
    target: 1000000,
    label: '1M',
    badge: '💎 Clube do Milhão (1M+)',
    rewardTitle: 'Clube dos 7 Dígitos Desbloqueado!',
    rewardDescription: 'Mais de 1 Milhão no mês! Conquista lendária no Master Club!',
    color: '#B026FF'
  }
];

export interface LeaderboardSeller {
  rank: number;
  user_id: string;
  full_name: string;
  avatar_url?: string;
  email: string;
  total_revenue: number;
  revenue_cop?: number;
  currency: string;
  exchange_rate_used?: number;
  total_orders: number;
  store_count?: number;
  store_breakdown?: StoreBreakdownItem[];
  current_milestone_target: number;
  claimed_milestones: string[];
  updated_at: string;
}
